module.exports = __webpack_public_path__ + "img/member-pic6.69117688.png";